import React from 'react';

import { Text, HStack, useColorModeValue } from 'native-base';
import { listStyle } from 'src/styles/listStyle';
import MaterialIconByName from '../MaterialIconByName';

interface TextWithIconProps {
    text: string | undefined;
    icon: string;
    numberOfLines?: number;
}

export default function TextWithIcon(props: TextWithIconProps) {
    const textColor = useColorModeValue('coolGray.800', 'coolGray.100');

    return <HStack
        style={{
            flexDirection: "row",
            alignItems: "center",
            flexShrink: 1,
        }}
        space={1}>
        <MaterialIconByName name={props.icon} />
        <Text
            color={textColor}
            numberOfLines={props.numberOfLines}
            style={[listStyle.textWithIcon, { flexShrink: 1 }]}>
            {props.text || ""}
        </Text>
    </HStack>
};
